import { ReactElement } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import classnames from 'classnames';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ReactComponent as PauseIcon } from '../../../../Patient/icons/PauseIcon.svg';

import { isoToFormat } from '~/utils/date';
import { PatientMonitoringPauseStatus } from '~/services/api/enums';
import { IPatientMonitoringPauseDto } from '~/services/api/patientMonitoringPauses/types';
import { Timezone } from '~/types';

import styles from './PauseMonitoringIndicator.module.scss';

interface IProps {
  pause: IPatientMonitoringPauseDto;
  timezone: Timezone;
}

const PauseMonitoringIndicator = ({ pause, timezone }: IProps): ReactElement | null => {
  const isPlannedPause = pause.statusId === PatientMonitoringPauseStatus.Planned;

  const startDate = `${isoToFormat(pause.startDate, 'dd MMM yyyy')} ${timezone}`;
  const endDate = `${isoToFormat(pause.endDate, 'dd MMM yyyy')} ${timezone}`;

  const tooltipTitle = (
    <div className={styles.tooltipContent}>
      <div className={styles.tooltipTitle}>
        {isPlannedPause ? 'Monitoring is going to be paused' : 'Monitoring is paused'}
      </div>
      <div>
        Period: {startDate} - {endDate}
      </div>
    </div>
  );

  return (
    <Tooltip title={tooltipTitle} placement="top" arrow classes={{ tooltip: styles.tooltip }}>
      {isPlannedPause ? (
        <InfoOutlinedIcon
          className={classnames(styles.pauseIcon, styles.pauseIconPlanned)}
          fontSize="small"
        />
      ) : (
        <PauseIcon
          className={classnames(styles.pauseIcon, styles.pauseSvgIcon, styles.pauseIconInProgress)}
        />
      )}
    </Tooltip>
  );
};

export default PauseMonitoringIndicator;
